export default {
  csrf: '',
  IS_DEV: process.env.NODE_ENV === 'development',
  DEV_URL: 'http://localhost:5001',
  PROD_URL: 'https://www.kuaian.vip'
  // PROD_URL: 'https://demo.kuaian.vip'
}